export const extractRoutesFromMenu = (menuCategories) => {
  const pages = [];

  menuCategories.forEach((group) => {
    group.items?.forEach((item) => {
      if (item.to) {
        pages.push({
          title: item.label,
          route: item.to,
        });
      }
    });
  });

  return pages;
};
